import { HTMLAttributes, forwardRef, CSSProperties } from 'react'

interface ScrollDivProps extends HTMLAttributes<HTMLDivElement> {
  widgetColor?: string
}

export const ScrollDiv = forwardRef<HTMLDivElement, ScrollDivProps>(
  ({ widgetColor, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`tw-scrollbar-widget ${className || ''}`}
        style={
          {
            '--widget-color': widgetColor || '#888',
            ...style,
          } as CSSProperties
        }
        {...props}
      />
    )
  },
)

ScrollDiv.displayName = 'ScrollDiv'

export const MessagesDiv = forwardRef<HTMLDivElement, ScrollDivProps>(
  ({ widgetColor, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`tw-scrollbar-widget ${className || ''}`}
        style={
          {
            '--widget-color': widgetColor || '#888',
            ...style,
          } as CSSProperties
        }
        {...props}
      />
    )
  },
)

MessagesDiv.displayName = 'MessagesDiv'

export const ChatsDiv = forwardRef<HTMLDivElement, ScrollDivProps>(
  ({ widgetColor, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`tw-scrollbar-widget ${className || ''}`}
        style={
          {
            '--widget-color': widgetColor || '#888',
            ...style,
          } as CSSProperties
        }
        {...props}
      />
    )
  },
)

ChatsDiv.displayName = 'ChatsDiv'
